import { createAction, createReducer, on, props } from '@ngrx/store';
import { UserAgentInitState } from '../models/user-agent.interface';

// Actions
export const UPDATE_USER_AGENT_DATA = createAction(
  '[UserAgent] Update User Agent Data',
  props<UserAgentInitState>()
);

export const UPDATE_USER_AGENT_BOOKING_REFERENCE = createAction(
  '[UserAgent] Update Booking Reference',
  props<{ bookingRef: string | null }>()
);

export const RESET_USER_AGENT_DATA = createAction(
  '[UserAgent] Reset User Agent Data'
);

// Initial State
const initState: UserAgentInitState = {
  ip: null,
  userAgentString: null,
  appVersion: null,
  dateTimeLocal: null,
  bookingRef: null,
};

// Reducer
export const userAgentReducer = createReducer(
  initState,

  on(UPDATE_USER_AGENT_DATA, (_, payload) => ({
    ...payload
  })),

  on(UPDATE_USER_AGENT_BOOKING_REFERENCE, (state, { bookingRef }) => ({
    ...state,
    bookingRef,
  })),

  on(RESET_USER_AGENT_DATA, () => ({
    ...initState
  }))
);
